"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var typestyle_1 = require("typestyle");

exports.wrapper = typestyle_1.style({
  display: "flex"
}, {
  justifyContent: "flex-start"
}, {
  width: "100%"
});
exports.container = typestyle_1.style({
  width: "100%"
});
exports.pictureWidget = typestyle_1.style({
  width: "100%"
}, {
  maxWidth: "100%"
}, {
  minWidth: "33%"
}, {
  padding: "16px"
}, {
  boxShadow: "0 0 0 0 #e8e9f1"
}, {
  borderRadius: "10px 10px 35px 10px"
}, {
  float: "left"
}, {
  height: "300px"
}, {
  background: "white"
});